// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import {MockPincodeService} from '../app/services/pincode/mock-pincode.service';

export const localEnvironment = {
  environment: 'local',
  production: false,
  translateURL: './assets/i18n/',
  translateSuffix: '.json',
  baseUrl: 'https://www.uat.telenet.be',
  pincodeServiceType: MockPincodeService,
  baseApiUrl: 'https://api.uat.telenet.be',
  baseApiUrlForInt: 'https://api.int.telenet.be',
  sofyApiUrl: 'https://uat.sofy-stage.awscloud.external.telenet.be/sofy/public/'
};

